import { zeroAddress } from 'viem'
import { Mainnet } from '~/model/chain/ethereum'
import {
  STETH_ADDRESS,
  WSTETH_ADDRESS,
  USDT as USDT_ADDRESSES,
} from '~/constants/addresses'
import ImgTokenETH from '~/assets/images/token-eth-with-bg.svg'
import ImgTokenStETH from '~/assets/images/token-steth-with-bg.png'
import ImgTokenWstETH from '~/assets/images/token-wsteth-with-bg.png'
import ImgTokenUSDT from '~/assets/images/token-usdt-with-bg.png'

export const ETH = {
  address: zeroAddress,
  decimals: 18,
  symbol: 'ETH',
  name: 'ETH',
  logo: ImgTokenETH,
}

export const stETH = {
  address: STETH_ADDRESS,
  decimals: 18,
  symbol: 'stETH',
  name: 'stETH',
  logo: ImgTokenStETH.src,
}

export const wstETH = {
  address: WSTETH_ADDRESS,
  decimals: 18,
  symbol: 'wstETH',
  name: 'wstETH',
  logo: ImgTokenWstETH.src,
}

export const USDT = {
  address: USDT_ADDRESSES[Mainnet.chainId],
  decimals: 6,
  symbol: 'USDT',
  name: 'USDT',
  logo: ImgTokenUSDT.src,
}
